import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAdminAuth } from '../../hooks/useAdminAuth'
import { ROUTES } from '../../config/constants'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAdminAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen bg-stadium-black flex items-center justify-center">
        <div className="text-pitch-green text-xl">Loading...</div>
      </div>
    )
  }

  if (!isAuthenticated()) {
    return <Navigate to={ROUTES.ADMIN_LOGIN} state={{ from: location }} replace />
  }

  return children
}
